module.exports = __webpack_public_path__ + "img/c08_unitranger_Normal_ua.a23ee986.webp";